import { render, staticRenderFns } from "./CustomerBase.vue?vue&type=template&id=14487ce9&"
import script from "./CustomerBase.vue?vue&type=script&lang=js&"
export * from "./CustomerBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports